import { Organization, OrganizationListObj } from 'types';
import {
    ORGANIZATION_FAILED,
    ORGANIZATION_LIST_FAILED,
    ORGANIZATION_LIST_REQUESTED,
    ORGANIZATION_LIST_SUCCESS,
    ORGANIZATION_REQUESTED,
    ORGANIZATION_SUCCESS,
} from './constants';

export type OrganizationState = {
    organization: Organization | null;
    organizations: OrganizationListObj[] | null;
    errorMessage: string;
    loading: boolean;
};

export const initialOrganizationState = {
    organization: null,
    organizations: null,
    errorMessage: '',
    loading: false,
};

export default function organizationReducer(
    state: OrganizationState = initialOrganizationState,
    action: any
): OrganizationState {
    const newState = { ...state };
    switch (action.type) {
        case ORGANIZATION_REQUESTED:
            newState.loading = true;
            newState.organization = null;
            newState.errorMessage = '';
            return newState;
        case ORGANIZATION_SUCCESS:
            newState.loading = false;
            newState.organization = action.payload.organization;
            return newState;
        case ORGANIZATION_FAILED:
            newState.loading = false;
            return newState;
        case ORGANIZATION_LIST_REQUESTED:
            newState.loading = true;
            return newState;
        case ORGANIZATION_LIST_SUCCESS:
            newState.loading = false;
            newState.organizations = action.payload.organizations;
            return newState;
        case ORGANIZATION_LIST_FAILED:
            newState.loading = false;
            newState.errorMessage = action.message;
            return newState;
        default:
            return state || initialOrganizationState;
    }
}
